import React, { useState } from "react";

const ContactForm = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        request: "",
        honeypot: "", // Hidden honeypot field
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (formData.honeypot) {
            console.warn("Honeypot triggered. Submission blocked.");
            return;
        }

        try {
            const response = await fetch("/api/googleSheets/contact-us", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                alert("Your message has been sent!");
                setFormData({ name: "", email: "", phone: "", request: "", honeypot: "" });
            } else {
                alert("Failed to send your message. Please try again.");
            }
        } catch (error) {
            console.error("Error submitting contact form:", error);
            alert("An error occurred. Please try again later.");
        }
    };

    return (
        <form onSubmit={handleSubmit}>
            <input
                type="text"
                name="name"
                placeholder="Name"
                value={formData.name}
                onChange={handleChange}
                required
            />
            <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
            />
            <input
                type="text"
                name="phone"
                placeholder="Phone"
                value={formData.phone}
                onChange={handleChange}
            />
            <textarea
                name="request"
                placeholder="Request"
                value={formData.request}
                onChange={handleChange}
                required
            />
            <input
                type="text"
                name="honeypot"
                value={formData.honeypot}
                onChange={handleChange}
                style={{ display: "none" }}
                tabIndex="-1"
                autoComplete="off"
            />
            <button type="submit">Submit</button>
        </form>
    );
};

export default ContactForm;
